import {getDevicesList, getListDevicesBulkEdit, pushDeviceBulkEdit} from "../../services/devices";
import {notificationError, notificationSucces} from "../../services/notification";
import React, {useEffect, useState} from "react";
import {IParams} from "../../context/ListRecordProvider/types";
import Head from "../../components/Head";
import List from "../../components/List";
import {compareDates, stringCompare} from "../../utils/sorters";
import SmartSearch from "../../components/UI/SmartSearch";
import Button from "../../components/UI/Button";
import {IJackpotHistoryItem} from "../JackpotHistory";
import dayjs from "dayjs";
import {DateFormatEnum} from "../../enums/dateFormatEnum";
import {getAllowCreateNewDevicePermission, getPermission} from "../../services/permisssion";
import permissionType from "../../utils/permissionType";
import {useLoading} from "../../context/LoadingProvider/useLoading";
import {useListRecord} from "../../context/ListRecordProvider/useListRecord";
import SelectInput from "../../components/UI/SelectInput";
import Input from "../../components/UI/Input";
import {TagsOutlined} from "@ant-design/icons";
import {Collapse, Divider, message, Modal, Space, TableProps, Tag} from "antd";
import {onlyLetters} from "../../utils/formValidation";
import devicesBulkEditActionList from "../../utils/devicesBulkEditActionList";
const { Panel } = Collapse;


function DeviceBulkEdit(props: {accessLevel: string;}) {
    const [locationParams, setLocationParams] = useState<IParams>({
        id: '',
        fieldOrder: '',
        directionOrder: '',
        name: '',
        type: '',
    })
    const [validSearch, setValidSearch] = useState(false)
    const [locationSearch, setLocationSearch] = useState('')
    const [form, setForm] = useState({
        devicesList: '',
        searchType: 'identifier'
    })
    const loading = useLoading()
    const [canCreateDevice, setCanCreateDevice] = useState(false)
    const listRecord = useListRecord()
    const record = listRecord.getRecord('devicesList')
    const [selectedRows, setRows] = useState<String[]>([])
    const [devicesList, setDevicesList] = useState({
        count: 0,
        page: null,
        perpage: 0,
        list: [],
    })
    const searchOptions = [
        {name: 'Device IDs', value: 'identifier'},
        {name: 'Location', value: 'location'},
        {name: 'Tag', value: 'tag'},
    ]
    const [action, setAction] = useState(devicesBulkEditActionList[0].value)

    useEffect(() => {
        (async() =>{
            loading.addLoading()
            if(form.devicesList !== '') {
                let requestParams = {
                    devices: form.devicesList,
                    fieldOrder: '',
                    directionOrder: ''
                }
                const response = await getListDevicesBulkEdit(requestParams)
                if(response.list.length >= 30000) {
                    notificationError('Device Limit Reached', 'Search returned over 30,000 results. Limiting to first 30,000. Please refine your search')
                }
                setDevicesList(response)
            }
            loading.removeLoading()
        })()
    }, [])

    const onRefresh = async () => {
        loading.addLoading()
        let requestParams = {
            deviceSearch: form.devicesList,
            searchType: form.searchType,
            fieldOrder: '',
            directionOrder: ''
        }
        const response = await getListDevicesBulkEdit(requestParams)
        if(response.list.length >= 30000) {
            notificationError('Device Limit Reached', 'Search returned over 30,000 results. Limiting to first 30,000. Please refine your search')
        }
        setDevicesList(response)
        loading.removeLoading()
    }

    const getStatusLabel = (status: string) => {
        if(status === 'AVAILABLE') {
            return <Tag color="green">{status}</Tag>
        }

        return <Tag color="red">{status}</Tag>

    }

    const onPushAction = async () => {
        if((action === devicesBulkEditActionList[4].value) && locationParams.id === '') return notificationError('Missing Location', 'Please provide a location for the selected action')
        loading.addLoading()

        let requestParams = {
            action,
            deviceIds: selectedRows,
            locationId: locationParams.id,
        }

        await pushDeviceBulkEdit(requestParams)
        loading.removeLoading()
        onRefresh()
    }

    return (
        <div className="devices">
            <meta name="viewport" content="width=device-width, initial-scale=.75"/>
            <Head
                title="All Devices"
            />
            <div className="action-area-component">
                <div className="devices__action-area">
                    <Input
                        label="Search"
                        value={form.devicesList}
                        onChange={(e: any) => setForm((prev) => ({...prev, devicesList: e.target.value}))}
                        style={{marginBottom: 0, width: '650px' }}
                    />
                    <SelectInput
                        options={searchOptions}
                        label='Search Options'
                        onSelectChange={(e: string) => setForm((prev) => ({...prev, searchType: e}))}
                        value={form.searchType}
                    />
                    <Button onClick={onRefresh} type="primary" >
                        <p>Search</p>
                    </Button>
                </div>
            </div>
            <div className="devices__action-container" >
                <Space>
                    <Collapse>
                        <Panel header="Device Actions" key={"deviceActions"}>
                            <div className="devices__action-area">
                                <SelectInput
                                    options={devicesBulkEditActionList}
                                    label='Action'
                                    onSelectChange={(e: string) => setAction(e)}
                                    value={action}
                                />
                                { (action === devicesBulkEditActionList[0].value || action === devicesBulkEditActionList[1].value || action === devicesBulkEditActionList[4].value)
                                    && <SmartSearch
                                        label="Smart Search"
                                        searchBy={['location']}
                                        value={locationSearch}
                                        onValidSearch={setValidSearch}
                                        triggerWith={record?.name || ''}
                                        onChange={(e) => setLocationSearch(e)}
                                        onObjValueChange={(e: any) => setLocationParams({...locationParams, ...e})}
                                        validOnEmpty
                                    />
                                }
                                <Button type="primary" disabled={devicesList.list.length === 0}
                                        onClick={() => onPushAction()} style={{height:'32px' ,backgroundColor: 'red'}}>
                                    <p>Push Action</p>
                                </Button>
                            </div>
                        </Panel>
                    </Collapse>
                </Space>
            </div>
            <List
                rowKey={"id"}
                rowSelection={{selectedRowKeys: selectedRows, onChange: (selectedRowKeys: React.Key[]) => {
                        setRows(selectedRowKeys.map(k => String(k)))
                    }}}
                rows={devicesList.list}
                columns={[
                    {
                        title: 'Device ID',
                        dataIndex: 'identifier',
                        key: 'identifier',
                        render: (value: string) => value,
                        sorter: (a: any, b: any) => stringCompare(a.identifier, b.identifier),
                        width: 150,
                    },
                    {
                        title: 'Alias',
                        dataIndex: 'alias',
                        key: 'alias',
                        render: (value: string) => value,
                        sorter: (a: any, b: any) => stringCompare(a.alias, b.alias),
                        width: 100
                    },
                    {
                        title: 'Serial',
                        dataIndex: 'serialNumber',
                        key: 'serialNumber',
                        render: (value: string) => value,
                        sorter: (a: any, b: any) => stringCompare(a.serialNumber!=null?a.serialNumber:"zzz", b.serialNumber!=null?b.serialNumber:"zzz"),
                        width: 100
                    },
                    {
                        title: 'Distributor',
                        dataIndex: 'distributor',
                        key: 'distributor',
                        render: (value: string) => value,
                        sorter: (a: any, b: any) => stringCompare(a.distributor, b.distributor),
                        width: 150
                    },
                    {
                        title: 'Charity',
                        dataIndex: 'charity',
                        key: 'charity',
                        render: (value: string) => value,
                        sorter: (a: any, b: any) => stringCompare(a.charity, b.charity),
                        width: 150
                    },
                    {
                        title: 'Location',
                        dataIndex: 'location',
                        key: 'location',
                        render: (value: string) => value,
                        sorter: (a: any, b: any) => stringCompare(a.location, b.location),
                        width: 150
                    },
                    {
                        title: 'Type',
                        dataIndex: 'type',
                        key: 'type',
                        render: (value: string) => value,
                        sorter: (a: any, b: any) => stringCompare(a.type, b.type),
                        width: 100
                    },
                    {
                        title: 'Internal IP',
                        dataIndex: 'lastKnownInternalIp',
                        key: 'lastKnownInternalIp',
                        render: (value: string) => value || '--',
                        sorter: (a: any, b: any) => stringCompare(a.lastKnownInternalIp || '--', b.lastKnownInternalIp || '--'),
                        width: 150
                    },
                    {
                        title: 'Version',
                        dataIndex: 'lastKnownVersion',
                        key: 'lastKnownVersion',
                        render: (value: string) => value || '--',
                        sorter: (a: any, b: any) => stringCompare(a.lastKnownVersion || '--', b.lastKnownVersion || '--'),
                        width: 100
                    },
                    {
                        title: 'Activation',
                        dataIndex: 'lastActivation',
                        key: 'lastActivation',
                        render: (value: string) => value,
                        sorter: (a: any, b: any) => compareDates(
                            a.lastActivation!=null?dayjs(a.lastActivation).format(DateFormatEnum.MONTH_DAY_YAEAR_TIME): dayjs(new Date(0)).format(DateFormatEnum.MONTH_DAY_YAEAR_TIME),
                            b.lastActivation!=null?dayjs(b.lastActivation).format(DateFormatEnum.MONTH_DAY_YAEAR_TIME): dayjs(new Date(0)).format(DateFormatEnum.MONTH_DAY_YAEAR_TIME),
                            DateFormatEnum.MONTH_DAY_YAEAR_TIME
                        ),
                        width: 150
                    },
                    {
                        title: 'Status',
                        dataIndex: 'status',
                        key: 'status',
                        render: (value: string) => getStatusLabel(value),
                        sorter: (a: any, b: any) => stringCompare(a.status, b.status),
                        width: 100
                    },
                ]}
            />
        </div>
    )
}

export default DeviceBulkEdit